import { Suspense } from 'react';
import { THREAD_VIEW, THREAD_LIST, KNOWLEDGE_BASE, KNOWLEDGE_BASE_ARTICLE, CATEGORY_VIEW } from 'conversations-visitor-experience-components/visitor-widget/constants/views';
import WidgetPlaceholder from 'conversations-visitor-experience-components/visitor-widget/components/WidgetPlaceholder';
import { lazyWithPreload } from '../../utils/lazyWithPreload';
import CategoryArticles from '../../knowledge-base/components/CategoryArticles';
import KBArticleContainer from '../../kb-article/components/KBArticleContainer';
import { postSdkCloseButtonClickEvent } from '../../mobile-sdk/actions/postSdkCloseButtonClickEvent';
import { isInSDK } from 'visitor-ui-component-library/utils/isInSDK';
import SideDockVisitorWidgetContainer from '../containers/SideDockVisitorWidgetContainer';
import { getSideDockWidth } from '../constants/sideDockConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadView = lazyWithPreload(() => import( /* webpackChunkName: "SideDock-ThreadView" */'../../components/ThreadView'));
const KnowledgeBaseContainer = lazyWithPreload(() => import( /* webpackChunkName: "SideDock-KnowledgeBaseContainerV2" */'../../knowledge-base/components/KnowledgeBaseContainerV2'));
const ThreadListContainer = lazyWithPreload(() => import( /* webpackChunkName: "SideDock-ThreadListContainer" */'../../containers/ThreadListContainer'));
const renderView = currentView => {
  if (!currentView) {
    return null;
  }
  switch (currentView) {
    case THREAD_VIEW:
      return /*#__PURE__*/_jsx(ThreadView, {});
    case KNOWLEDGE_BASE:
      return /*#__PURE__*/_jsx(KnowledgeBaseContainer, {});
    case THREAD_LIST:
      return /*#__PURE__*/_jsx(ThreadListContainer, {});
    case CATEGORY_VIEW:
      return /*#__PURE__*/_jsx(CategoryArticles, {});
    case KNOWLEDGE_BASE_ARTICLE:
      return /*#__PURE__*/_jsx(KBArticleContainer, {});
    default:
      return /*#__PURE__*/_jsx(WidgetPlaceholder, {});
  }
};
const SideDockCurrentView = ({
  browserWindowHeight,
  browserWindowWidth,
  closeWidget,
  currentView,
  enableSdkCloseButton
}) => {
  const isInSdk = isInSDK();
  let closeButtonClickHandler;
  if (enableSdkCloseButton) {
    closeButtonClickHandler = postSdkCloseButtonClickEvent;
  } else if (!isInSdk) {
    closeButtonClickHandler = closeWidget;
  }
  if (!currentView) {
    return null;
  }
  const sideDockWidgetSize = {
    width: getSideDockWidth(browserWindowWidth),
    height: browserWindowHeight
  };
  return /*#__PURE__*/_jsx("div", {
    style: {
      height: '100%'
    },
    id: "side-dock-current-view",
    children: /*#__PURE__*/_jsx(SideDockVisitorWidgetContainer, {
      browserWindowHeight: browserWindowHeight,
      browserWindowWidth: browserWindowWidth,
      closeWidget: closeButtonClickHandler,
      view: currentView,
      widgetSize: sideDockWidgetSize,
      children: /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(WidgetPlaceholder, {}),
        children: renderView(currentView)
      })
    })
  });
};
SideDockCurrentView.displayName = 'SideDockCurrentView';
export default SideDockCurrentView;